module.exports = __webpack_public_path__ + "static/media/shouye.0ac7e21c.png";